
import { mapState } from 'vuex'
export default {
    data() {
        return {
            dragXStart: 0,
            pModel: 0,
            cryptoWallets: [],
        }
    },
    computed: {
        ...mapState({
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
        }),
    },
    watch: {
        playerCryptoWallets(value) {
            if (value?.length > 0) {
                this.cryptoWallets = [...value, { id: null }]
            }
        },
    },
    mounted() {
        this.$store.dispatch('themes/player-bank/playerCryptoWallet')
    },
    methods: {
        onNext() {
            window.document.getElementById('next-crypto-button').click()
        },
        onBack() {
            window.document.getElementById('back-crypto-button').click()
        },
        onNextTrick(evt) {
            if (this.pModel + 1 < this.playerCryptoWallets?.length + 1)
                this.pModel += 1
        },
        onPrevTrick(evt) {
            if (this.pModel - 1 >= 0) this.pModel -= 1
        },
        evtDragStart(evt) {
            this.dragXStart = evt?.clientX
        },
        evtDragEnd(evt) {
            const dragXEnd = evt?.clientX
            if (dragXEnd > this.dragXStart) {
                this.onBack()
            } else if (dragXEnd < this.dragXStart) {
                this.onNext()
            }
            this.dragXStart = 0
        },
        onEditCryptoAccount(item) {
            this.$router.push('/payment-methods/edit/crypto/' + item.id)
        },
    },
}
